import { createDict } from '@/util/dicts'

export const dicts = {
  computed:{
    partsCate(){
      return new Promise((resolve , reject) => {
        return this.$request.assPartsCatesAll().then( resp => {
          let groups = createDict('genre')
          let groups_table = this.$utils.map(groups,'value')
          for(let i of (resp.data || [])){
            let hit = groups_table[i.genre]
            if( hit ){
              if( !hit.children ){
                hit.children = []
              }
              hit.children.push({label:i.categoryName , value:i.id})
            }
          }
          console.log(groups)
          resolve( groups.filter(i => !!i.children) )
        })
      })
    }
  }
}